import $ from 'jquery';
import imagesLoaded from 'imagesloaded';

let lastScrollTop = 0;

/**
 *
 */
export function textUtils() {

}

/**
 *
 */
export function pageLoadUtils() {
  imagesLoaded.makeJQueryPlugin($);

  $('body').imagesLoaded(function() {
    $('body').addClass('loaded').trigger('loaded');
  });

  $('.accordion-item').eq(0).addClass('active');

  $('.collapse').each(function() {
    $(this)[0].addEventListener('show.bs.collapse', () => {
      $(this).parents('.accordion-item').siblings('.accordion-item').removeClass('active');
      $(this).parents('.accordion-item').addClass('active');
    });

    $(this)[0].addEventListener('hide.bs.collapse', () => {
      $(this).parents('.accordion-item').removeClass('active');
    });
  });
}

export function bodyUtils() {
  imagesLoaded.makeJQueryPlugin($);

  $('body').imagesLoaded(function() {
    $('body').addClass('is-loaded').trigger('loaded');
  });

  $('.is-style-link:not(:has(*)), .is-style-link:has(.screen-reader-text)').each(function() {
    const svgElement = '<svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="currentColor" viewBox="0 0 320 512"><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg>';

    $(this).append(svgElement);
  });

  $('.wp-block-button.is-style-link .wp-block-button__link').each(function() {
    const svgElement = '<svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="currentColor" viewBox="0 0 320 512"><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg>';

    $(this).append(svgElement);
  });

  $('.site-header .wp-block-navigation__submenu-container').each(function() {
    $(this).prepend('<button aria-label="Close submenu" class="submenu-close-btn">Back</button>');
  });

  $('.wp-block-navigation-submenu__toggle').on('click', function() {
    const $parent = $(this).parent();
    const $submenu = $(this).siblings('.wp-block-navigation-submenu');

    // Flag to track if transitionend has already been handled
    let transitionHandled = false;

    $submenu.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
      if (!transitionHandled) {
        $parent.toggleClass('submenu-open');
        transitionHandled = true;
      }
    });
  });

  $('.submenu-close-btn').on('click', function() {
    $(this).parent().siblings('.wp-block-navigation-submenu__toggle').trigger('click');
  });

  $(document).on('click', '.wp-block-navigation-item:not(.has-child)', () => {
    $('.wp-block-navigation__responsive-container-close').trigger('click');
  });

  $('.entry-content p, .entry-content li').each(function() {
    // Get the current color of the element
    const currentColor = $(this).css('color');

    // Check if the color is already rgba, if not convert it to rgba with 0.85 opacity
    const rgbaColor = currentColor.replace(/^rgb/, 'rgba').replace(')', ',0.85)');

    // Apply the new color with opacity
    $(this).css('color', rgbaColor);

    // Find any <strong> or <b> elements within this element and reset their opacity
    $(this).find('strong, b').each(function() {
      $(this).css('color', currentColor);
    });
  });
}

/**
 *
 */
export function buttonUtils() {
  $('.btn, .wp-block-button a').append('<span class="btn-inner></span>');

  $('.faq > div > h3').on('click', function() {
    $(this).parents('.faq').toggleClass('active');
    $(this).parents('.faq').siblings('.faq').removeClass('active');
  });
}

/**
 *
 */
export function windowScrollUtils() {
  const $body = $('body');
  let st = $(window).scrollTop();
  const scrollThreshold = 20;

  if (st < ( lastScrollTop - scrollThreshold )) {
    $body.removeClass('header-hidden');
    $body.addClass('header-sticky');
  }

  if (st > lastScrollTop) {
    $body.addClass('header-hidden');
    $body.removeClass('header-sticky');
  }

  if (st < 50) {
    $body.addClass('header-top');
    $body.removeClass('header-sticky');
    $body.removeClass('header-hidden');
  }

  if (st > 50) {
    $body.removeClass('header-top');
  }

  lastScrollTop = st;
}
